import React from 'react';

export default function getGroupProgrammes(groupOptionsDetailed = null) {

    if (!groupOptionsDetailed?.length) return;

    let filteredOptions = []

    for (let option of groupOptionsDetailed)
    {
        if (!filteredOptions.includes(option.programe))
        {
            filteredOptions.push(option.programe)
        }
    }

    filteredOptions.sort()

    let formattedOptions = []
    for (let option of filteredOptions)
    {
        formattedOptions.push({
            value: option,
            label: option,
        })
    }

    return formattedOptions;
};
